import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import { OverlayTrigger, Tooltip } from 'bundles/enterprise-ui';

import _t from 'i18n!nls/enterprise-admin-users';

import 'css!./__styles__/ArrayToStringCell';

const countStyle: React.CSSProperties = {
  borderBottom: `1px dashed`,
};

type Props = {
  entries: Array<string>;
};

type State = {
  showTooltip: boolean;
};

class ArrayToStringCell extends React.Component<Props> {
  state: State = {
    showTooltip: false,
  };

  toggleOverlay = (value: boolean) => () => {
    setTimeout(() => {
      this.setState({ showTooltip: value });
    }, 500);
  };

  render() {
    const { entries: allEntries } = this.props;
    const entries = allEntries.filter((_) => _);
    const { showTooltip } = this.state;
    const entryCount = entries && entries.length;
    let content;
    if (!entryCount) {
      return <span>-</span>;
    } else if (entryCount === 1) {
      [content] = entries;
    } else {
      const tooltip = (
        <Tooltip>
          <div
            onMouseEnter={this.toggleOverlay(true)}
            onMouseLeave={this.toggleOverlay(false)}
            className="c-ArrayToStringCellTooltip vertical-box"
          >
            {entries.slice(1).map((entry, index) => (
              <p key={String(entry + index)} className="c-tooltipTextLine">
                {entry}
              </p>
            ))}
          </div>
        </Tooltip>
      );

      const overlay = (
        <span onMouseEnter={this.toggleOverlay(true)} onMouseLeave={this.toggleOverlay(false)}>
          <OverlayTrigger show={showTooltip} placement="right" overlay={tooltip}>
            <Typography2 component="p" color="highlightBlue" style={countStyle}>
              {_t('+#{count} more', { count: entryCount - 1 })}
            </Typography2>
          </OverlayTrigger>
        </span>
      );

      content = (
        <FormattedMessage message={_t('{firstEntry} ({entryCount})')} firstEntry={entries[0]} entryCount={overlay} />
      );
    }

    return <div className="rc-ArrayToStringCell">{content}</div>;
  }
}

export default ArrayToStringCell;
